import { render, staticRenderFns } from "./ADDEDTOPORTFOLIO.vue?vue&type=template&id=28884552"
import script from "./ADDEDTOPORTFOLIO.vue?vue&type=script&lang=js"
export * from "./ADDEDTOPORTFOLIO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports